import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  toggleSortByOldest,
  getSortByOldest,
} from '../../store/slices/domainOrchestratorPricingCommittee.slice';

export const SortByDateButton = () => {
  const dispatch = useDispatch();
  const sortByOldest = useSelector(getSortByOldest);

  const handleClick = () => {
    dispatch(toggleSortByOldest());
  };

  return (
    <Button
      variant="outline-secondary"
      className="p-1 text-muted bg-white border-1 border-muted"
      onClick={handleClick}
      data-testid="sort-date-button"
      style={{ fontSize: '14px' }}
    >
      {sortByOldest ? 'Más antiguos' : 'Más recientes'}
    </Button>
  );
};
